import { LOCALE } from "../../../constant";
import { dateToTimestamp, isHourLimit, isOld } from "../../../utils/time/time";
import { Article } from "../Article/ArticlesTypes";
import { Reservation, IReservationDay } from "./ReservationsTypes";

const getDailyReservations = (
  reservations: Reservation[],
  startingDate: number,
  quota: number | undefined,
  quotaTotalMax: number | undefined,
  idDepartment: number | undefined,
  articles: Article[],
  numberOfReservations: string | undefined,
  coworkerHourLimit: string | undefined
): IReservationDay[] => {

  const dailyReservations: IReservationDay[] = [];
  const numberOfDayInaWeek = 5;
  if (!numberOfReservations){
    numberOfReservations = "0"
  }
  if (!coworkerHourLimit){
    coworkerHourLimit = "0"
  }

  //sort all reservations for each day of the week
  for (let index = 0; index < numberOfDayInaWeek; index++) {
    //Get the date of the day at 00h00
    const startingDateTimestamp = startingDate * 1000;

    const dayAtIndex: Date = new Date(startingDateTimestamp);
    dayAtIndex.setDate(dayAtIndex.getDate() + index);

    //Get the name of the day
    const wordDay: string = dayAtIndex.toLocaleDateString(LOCALE, { weekday: 'long' });
    const dayName: string = wordDay[0].toUpperCase() + wordDay.slice(1).toLowerCase()

    let reservationsDepartmentFiltered: Reservation[] = [];
    //Filter reservations to exclude : older reservation, reservations that are not in the current department of the user, and check if the hour for mixing all departement is now or not
    reservationsDepartmentFiltered = isOld(startingDate) || (isHourLimit(coworkerHourLimit, startingDate - 86_400) && isOld(startingDate - 86_400)) ? reservations : reservations.filter(reservation => reservation.user.idDepartment === idDepartment!);

    const reservationForDayAtIndex: Reservation[] = reservationsDepartmentFiltered.filter(reservation => reservation.date >= dateToTimestamp(dayAtIndex) && reservation.date <= dateToTimestamp(dayAtIndex) + 28_800);
    
    //Filtrer les articles par jour de reservations
    let sortedArticles: Article[]=[]

    if (articles){
      const filteredArticles = articles.filter(article => 
          article.startDate - 28_800 <= dateToTimestamp(dayAtIndex) && article.endDate + 28_800 >= dateToTimestamp(dayAtIndex) && (article.categoryId !== 3 && article.categoryId !== 4)
      );
      sortedArticles = filteredArticles.sort((a, b) => a.startDate - b.startDate);
    }

    //Create an Array for each Reservation of the week
    dailyReservations.push({
      date: dateToTimestamp(dayAtIndex),
      dayName: dayName,
      quota: quota,
      Reservations: reservationForDayAtIndex,
      Articles: sortedArticles,
      WaitingList: []
    })
  }

  //Sort every reservation from the previous array in a waitingList
  for (const dailyReservation of dailyReservations) {
    dailyReservation.Reservations.sort((r1: Reservation, r2: Reservation) => r1.priority - r2.priority || r1.creationDate - r2.creationDate);

    const waitingList: Reservation[] = [];
    //if it's a past day or after 5pm (or whatever hour it set to) no high/low priority sorting
    if (isOld(dailyReservation.date) || (isHourLimit(coworkerHourLimit, dailyReservation.date - 86_400) || isOld(dailyReservation.date - 86_400))) {

      dailyReservation.quota = quotaTotalMax;
      //pushing every reservations above the current quota in the waitingList
      for (let index = dailyReservation.quota!; index < dailyReservation.Reservations.length; index++) {
       
        waitingList.push(dailyReservation.Reservations[index]);
      }
    } else {
      //filtering reservations in 2 arrays High and Low priority 
      //3 of priority meaning 2 reservations or 1 reservation + you are External (base priority = internal+1)
      const highPriorityReservations = dailyReservation.Reservations.filter((reservation) => reservation.priority > Number.parseInt(numberOfReservations));
      const lowPriorityReservations = dailyReservation.Reservations.filter((reservation) => reservation.priority <= Number.parseInt(numberOfReservations));
      //pushing ever low priority reservation above the current quota in the waitingList
      for (let index = dailyReservation.quota!; index < lowPriorityReservations.length; index++) {
        waitingList.push(lowPriorityReservations[index]);
      }
      // pushing every High priority in the waitingList
      waitingList.push(...highPriorityReservations);
    }
    //filtering every Reservations in the waitingList from the global Reservations list
    const filteredReservations = dailyReservation.Reservations.filter((reservation) => !waitingList.includes(reservation));
    dailyReservation.Reservations = filteredReservations;
    dailyReservation.WaitingList = isOld(dailyReservation.date) ? [] : waitingList;
  }
  return dailyReservations

};

export { getDailyReservations };


